import HelpPage from './HelpPage';
import FaqPage from './faq/FaqPage';
import ContactPage from './contact/ContactPage';
import PageTabs from '../../../../layouts';
import FAQContent from './faq/FAQContent';

export {
	HelpPage,
	FaqPage,
	ContactPage,
	PageTabs,
	FAQContent,
};


// WEBPACK FOOTER //
// src/client/components/site/features/help/index.js